import menuItem from './menuItem';
import menuTitle from './menuTitle';
export default {
  name: 'subMenu',
  components: {
    menuItem,
    menuTitle
  },
  props: {
    currentRoute: {
      type: Object,
      required: true
    },
    customerId: {
      type: Number,
      required: true
    }
  },
  methods: {
    visibleChange(val) {
      console.log(val);
    }
  }
};